module.exports = __webpack_public_path__ + "img/curtain_up_20.a9ef2e5f.svg";